












import { defineComponent } from '@vue/composition-api';
import CommonHeader from '@/components/Navigation/CommonHeader.vue';
import { useStore } from '@/store';
import { ActionTypes } from '@/store/actions';
import ListViewLink from '@/components/Navigation/ListViewLink.vue';

export default defineComponent({
    name: 'ComparisonViewHeader',
    components: { ListViewLink, CommonHeader },
    setup () {
        function toggleView (): void {
            useStore().dispatch(ActionTypes.SetIsComparing, false);
        }
        return { toggleView };
    }
});
